import { render, staticRenderFns } from "./notification-IssueValidationFlowAssigned.vue?vue&type=template&id=2669aa9f&scoped=true"
import script from "./notification-IssueValidationFlowAssigned.vue?vue&type=script&lang=js"
export * from "./notification-IssueValidationFlowAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2669aa9f",
  null
  
)

export default component.exports